/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { cleanExternalLinks } from '../../lib/utils';

import styles from '../../../styles/typography/body.module.css';

const propTypes = {
    className: PropTypes.string,
    body: PropTypes.string,
    tag: PropTypes.string,
};

const Body = ({ className = null, body = null, tag = 'div' }) => {
    const Tag = `${tag || 'div'}`;
    return (
        <Tag
            className={classNames(styles.container, { [className]: className !== null })}
            dangerouslySetInnerHTML={{
                __html: cleanExternalLinks(body),
            }}
        />
    );
};

Body.propTypes = propTypes;

export default Body;
